import React from "react"
import { RouteComponentProps, withRouter } from "react-router-dom"
import PreviewCard from "../components/PreviewCard";

const PreviewView: React.FC<any&RouteComponentProps> = () => {
  return (
    <>
      <PreviewCard/>
    </>
  )
}
export default withRouter(PreviewView)
